import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import apiCall from '../apiCall';

import GameMaterials from './GameMaterials';

const GamePageContent = (props) => {
  const [items, setItems] = useState([]);
  const [fetched, setFetched] = useState(false);
  const gameId = parseInt(props.game.Game.id, 10);

  function fetchItems() {
    if (fetched) {
      return false;
    }
    setFetched(true);
    let itemName = '';
    switch(gameId) {
      case 4: // Escape Route
        itemName = 'escapeRouteItem';
        break
      case 11: // True Comics
        itemName = 'trueComicsItem';
        break;
      default:
        break;
    }
    return apiCall(`/${itemName}/${props.schoolClass.LanguageId}/${props.schoolClass.DifficultyId}`)
      .then((result) => {
        setItems(result);
      });
  }

  useEffect(() => {
    fetchItems();
  });

  switch (gameId) {
    case 4: // Escape Route
      return <GameMaterials gameId={4} items={items} />;
    case 11: // True comics
      return <GameMaterials gameId={11} items={items} />;
    default:
      return null;
  }
};

// GamePageContent.propTypes = {
//   Game: PropTypes.shape({
//     id: PropTypes.any.isRequired,
//   }).isRequired,
// };

export default connect(({schoolClass, group}) => ({schoolClass, group}))(GamePageContent);



// WEBPACK FOOTER //
// ./src/components/elements/GamePageContent.js